module.exports = __webpack_public_path__ + "media/images/icon/icons8-Zoom In-761fe2ee35855e05fc8ecace41a010a3.png";